"use strict";
"use client";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/toggle-group/src/index.ts
var src_exports = {};
__export(src_exports, {
  Item: function Item() {
    return Item2;
  },
  Root: function Root() {
    return Root2;
  },
  ToggleGroup: function ToggleGroup() {
    return _ToggleGroup;
  },
  ToggleGroupItem: function ToggleGroupItem() {
    return _ToggleGroupItem;
  },
  createToggleGroupScope: function createToggleGroupScope() {
    return _createToggleGroupScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/toggle-group/src/toggle-group.tsx
var import_react = __toESM(require("react"));
var import_react_context = require("@radix-ui/react-context");
var import_react_primitive = require("@radix-ui/react-primitive");
var RovingFocusGroup = __toESM(require("@radix-ui/react-roving-focus"));
var import_react_roving_focus = require("@radix-ui/react-roving-focus");
var import_react_toggle = require("@radix-ui/react-toggle");
var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");
var import_react_direction = require("@radix-ui/react-direction");
var import_jsx_runtime = require("react/jsx-runtime");
var TOGGLE_GROUP_NAME = "ToggleGroup";
var _ref = (0, import_react_context.createContextScope)(TOGGLE_GROUP_NAME, [import_react_roving_focus.createRovingFocusGroupScope]),
  _ref2 = _slicedToArray(_ref, 2),
  createToggleGroupContext = _ref2[0],
  _createToggleGroupScope = _ref2[1];
var useRovingFocusGroupScope = (0, import_react_roving_focus.createRovingFocusGroupScope)();
var _ToggleGroup = import_react.default.forwardRef(function (props, forwardedRef) {
  var type = props.type,
    toggleGroupProps = _objectWithoutProperties(props, ["type"]);
  if (type === "single") {
    var singleProps = toggleGroupProps;
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupImplSingle, _objectSpread({}, singleProps, {
      ref: forwardedRef
    }));
  }
  if (type === "multiple") {
    var multipleProps = toggleGroupProps;
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupImplMultiple, _objectSpread({}, multipleProps, {
      ref: forwardedRef
    }));
  }
  throw new Error("Missing prop `type` expected on `".concat(TOGGLE_GROUP_NAME, "`"));
});
_ToggleGroup.displayName = TOGGLE_GROUP_NAME;
var _createToggleGroupCon = createToggleGroupContext(TOGGLE_GROUP_NAME),
  _createToggleGroupCon2 = _slicedToArray(_createToggleGroupCon, 2),
  ToggleGroupValueProvider = _createToggleGroupCon2[0],
  useToggleGroupValueContext = _createToggleGroupCon2[1];
var ToggleGroupImplSingle = import_react.default.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange = props.onValueChange,
    onValueChange = _props$onValueChange === void 0 ? function () {} : _props$onValueChange,
    toggleGroupSingleProps = _objectWithoutProperties(props, ["value", "defaultValue", "onValueChange"]);
  var _ref3 = (0, import_react_use_controllable_state.useControllableState)({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    value = _ref4[0],
    setValue = _ref4[1];
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupValueProvider, {
    scope: props.__scopeToggleGroup,
    type: "single",
    value: value ? [value] : [],
    onItemActivate: setValue,
    onItemDeactivate: import_react.default.useCallback(function () {
      return setValue("");
    }, [setValue]),
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupImpl, _objectSpread({}, toggleGroupSingleProps, {
      ref: forwardedRef
    }))
  });
});
var ToggleGroupImplMultiple = import_react.default.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange2 = props.onValueChange,
    onValueChange = _props$onValueChange2 === void 0 ? function () {} : _props$onValueChange2,
    toggleGroupMultipleProps = _objectWithoutProperties(props, ["value", "defaultValue", "onValueChange"]);
  var _ref5 = (0, import_react_use_controllable_state.useControllableState)({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    _ref6$ = _ref6[0],
    value = _ref6$ === void 0 ? [] : _ref6$,
    setValue = _ref6[1];
  var handleButtonActivate = import_react.default.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return [].concat(_toConsumableArray(prevValue), [itemValue]);
    });
  }, [setValue]);
  var handleButtonDeactivate = import_react.default.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return prevValue.filter(function (value2) {
        return value2 !== itemValue;
      });
    });
  }, [setValue]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupValueProvider, {
    scope: props.__scopeToggleGroup,
    type: "multiple",
    value: value,
    onItemActivate: handleButtonActivate,
    onItemDeactivate: handleButtonDeactivate,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupImpl, _objectSpread({}, toggleGroupMultipleProps, {
      ref: forwardedRef
    }))
  });
});
_ToggleGroup.displayName = TOGGLE_GROUP_NAME;
var _createToggleGroupCon3 = createToggleGroupContext(TOGGLE_GROUP_NAME),
  _createToggleGroupCon4 = _slicedToArray(_createToggleGroupCon3, 2),
  ToggleGroupContext = _createToggleGroupCon4[0],
  useToggleGroupContext = _createToggleGroupCon4[1];
var ToggleGroupImpl = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeToggleGroup = props.__scopeToggleGroup,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$rovingFocus = props.rovingFocus,
    rovingFocus = _props$rovingFocus === void 0 ? true : _props$rovingFocus,
    orientation = props.orientation,
    dir = props.dir,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    toggleGroupProps = _objectWithoutProperties(props, ["__scopeToggleGroup", "disabled", "rovingFocus", "orientation", "dir", "loop"]);
  var rovingFocusGroupScope = useRovingFocusGroupScope(__scopeToggleGroup);
  var direction = (0, import_react_direction.useDirection)(dir);
  var commonProps = _objectSpread({
    role: "group",
    dir: direction
  }, toggleGroupProps);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupContext, {
    scope: __scopeToggleGroup,
    rovingFocus: rovingFocus,
    disabled: disabled,
    children: rovingFocus ? /* @__PURE__ */(0, import_jsx_runtime.jsx)(RovingFocusGroup.Root, _objectSpread({
      asChild: true
    }, rovingFocusGroupScope, {
      orientation: orientation,
      dir: direction,
      loop: loop,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread({}, commonProps, {
        ref: forwardedRef
      }))
    })) : /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread({}, commonProps, {
      ref: forwardedRef
    }))
  });
});
var ITEM_NAME = "ToggleGroupItem";
var _ToggleGroupItem = import_react.default.forwardRef(function (props, forwardedRef) {
  var valueContext = useToggleGroupValueContext(ITEM_NAME, props.__scopeToggleGroup);
  var context = useToggleGroupContext(ITEM_NAME, props.__scopeToggleGroup);
  var rovingFocusGroupScope = useRovingFocusGroupScope(props.__scopeToggleGroup);
  var pressed = valueContext.value.includes(props.value);
  var disabled = context.disabled || props.disabled;
  var commonProps = _objectSpread({}, props, {
    pressed: pressed,
    disabled: disabled
  });
  var ref = import_react.default.useRef(null);
  return context.rovingFocus ? /* @__PURE__ */(0, import_jsx_runtime.jsx)(RovingFocusGroup.Item, _objectSpread({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled,
    active: pressed,
    ref: ref,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupItemImpl, _objectSpread({}, commonProps, {
      ref: forwardedRef
    }))
  })) : /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToggleGroupItemImpl, _objectSpread({}, commonProps, {
    ref: forwardedRef
  }));
});
_ToggleGroupItem.displayName = ITEM_NAME;
var ToggleGroupItemImpl = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeToggleGroup = props.__scopeToggleGroup,
    value = props.value,
    itemProps = _objectWithoutProperties(props, ["__scopeToggleGroup", "value"]);
  var valueContext = useToggleGroupValueContext(ITEM_NAME, __scopeToggleGroup);
  var singleProps = {
    role: "radio",
    "aria-checked": props.pressed,
    "aria-pressed": void 0
  };
  var typeProps = valueContext.type === "single" ? singleProps : void 0;
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_toggle.Toggle, _objectSpread({}, typeProps, itemProps, {
    ref: forwardedRef,
    onPressedChange: function onPressedChange(pressed) {
      if (pressed) {
        valueContext.onItemActivate(value);
      } else {
        valueContext.onItemDeactivate(value);
      }
    }
  }));
});
var Root2 = _ToggleGroup;
var Item2 = _ToggleGroupItem;